import { ViewsLicenseStore } from "enterprise/parameters/stores/ViewsLicenseStore";
const validLicensePresent = () => {
  const license = ViewsLicenseStore.getInitialState();
  return license && !license.missing && license.status && license.status.valid;
};
export default validLicensePresent;
